/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import useProveedor from "../../hooks/useProveedor";
import ModalAdd from "./Modals/ModalAdd";
import DataTable from "../../components/DataTable/DataTable";
import Title from "../../components/Form/Title";
import ReadOnlyNote from "../../components/Form/ReadOnlyNote";
import {hideLoader, showLoader, setTitle} from "../../reducers/loaderReducer";
import {useDispatch} from "react-redux";
import useLogin from "../../hooks/useLogin";
import Swal from "sweetalert2";

const razonSocial = (row) =>
  row.tipo_persona === "Fisica"
    ? [row.nombre, row.apellido_p, row.apellido_m].filter(Boolean).join(" ")
    : row.nombre;

export default function Index() {
  const { token, cliente_id, user_rol } = useLogin();
  const dispatch = useDispatch();
  const { loading, error, message, success, Proveedores, ProveedorGetService, ProveedorDeleteService } = useProveedor();
  const [modal, setModal] = useState(false);
  const [Update, setUpdate] = useState(false);
  const [Id, setId] = useState("");
  const [TipoPersona, setTipoPersona] = useState("");
  const [Nombre, setNombre] = useState("");
  const [ApellidoP, setApellidoP] = useState("");
  const [ApellidoM, setApellidoM] = useState("");
  const [RFC, setRFC] = useState("");
  const [Correo, setCorreo] = useState("");
  const [Telefono, setTelefono] = useState("");
  const [UsoCFDI, setUsoCFDI] = useState("");
  const [Banco, setBanco] = useState("");
  const [Clabe, setClabe] = useState("");
  const [ClienteActualId, setClienteActualId] = useState("");
  const canManage = user_rol === "super administrador" || user_rol === "cliente";

  const toggle = () => {
    setModal(!modal);
    setUpdate(false);
    setId("");
    setTipoPersona("");
    setNombre("");
    setApellidoP("");
    setApellidoM("");
    setRFC("");
    setCorreo("");
    setTelefono("");
    setUsoCFDI("");
    setBanco("");
    setClabe("");
    setClienteActualId("");
  };

  // Ven el listado completo (incluye enlaces sin proveedor registrado, para
  // poder detectarlos y completarlos/limpiarlos): super admin, administrador
  // y contabilidad. Un cliente sólo ve sus propios proveedores ya registrados.
  const veTodos =
    user_rol === "super administrador" ||
    user_rol === "administrador" ||
    user_rol === "contabilidad";

  useEffect(() => {
    dispatch(setTitle("Descargando proveedores"));
    dispatch(showLoader());
    ProveedorGetService(veTodos ? 0 : cliente_id, token);
    return () => {};
  }, []);

  useEffect(() => {
    if (Proveedores.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
    return () => {};
  }, [Proveedores]);

  useEffect(() => {
    if (success === true) {
      ProveedorGetService(veTodos ? 0 : cliente_id, token);
    }
  }, [ProveedorGetService, success]);

  const Eliminar = (e) => {
    Swal.fire({
      title: "¿Eliminar proveedor?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((resultado) => {
      if (!resultado.isConfirmed) return;

      const data = new FormData();
      data.append("id", e);
      ProveedorDeleteService(data, token);

      Swal.fire({
        title: "Espere por favor...",
        text: "Cargando...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        icon: "question",
        onOpen: () => {
          Swal.showLoading();
        },
      });
    });
  };

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  useEffect(() => {
    if (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, error]);

  const columns = [];

  if (user_rol === "super administrador") {
    columns.push({ field: "nombre_comercial", title: "Cliente" });
  }

  columns.push(
    { field: "tipo_persona", title: "Tipo de persona" },
    {
      field: "Razon Social",
      title: "Razón social",
      sortable: false,
      filterValue: razonSocial,
      render: (row) => razonSocial(row),
    },
    { field: "RFC", title: "RFC" },
    { field: "correo", title: "Correo" },
    { field: "telefono", title: "Teléfono" }
  );

  if (canManage) {
    columns.push({
      field: "Acciones",
      title: "Acciones",
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <div className="crud-actions">
          <button
            className="crud-icon-btn edit"
            title="Editar"
            onClick={() => {
              setId(row.id);
              setTipoPersona(row.tipo_persona);
              setNombre(row.nombre);
              setApellidoP(row.apellido_p);
              setApellidoM(row.apellido_m);
              setRFC(row.RFC);
              setCorreo(row.correo);
              setTelefono(row.telefono);
              setUsoCFDI(row.cfdi_id);
              setBanco(row.banco ?? "");
              setClabe(row.clabe ?? "");
              setClienteActualId(row.cliente_actual_id ?? "");
              setUpdate(true);
              setModal(true);
            }}
          >
            <i className="bi bi-pencil"></i> Editar
          </button>
          <button
            className="crud-icon-btn delete"
            title="Eliminar"
            onClick={() => {
              Eliminar(row.id);
            }}
          >
            <i className="bi bi-trash"></i> Eliminar
          </button>
        </div>
      ),
    });
  }

  return (
    <>
      <ModalAdd
        modal={modal}
        toggle={toggle}
        Id={Id}
        Update={Update}
        token={token}
        TipoPersona={TipoPersona}
        setTipoPersona={setTipoPersona}
        Nombre={Nombre}
        setNombre={setNombre}
        ApellidoP={ApellidoP}
        setApellidoP={setApellidoP}
        ApellidoM={ApellidoM}
        setApellidoM={setApellidoM}
        RFC={RFC}
        setRFC={setRFC}
        Correo={Correo}
        setCorreo={setCorreo}
        Telefono={Telefono}
        setTelefono={setTelefono}
        UsoCFDI={UsoCFDI}
        setUsoCFDI={setUsoCFDI}
        Banco={Banco}
        setBanco={setBanco}
        Clabe={Clabe}
        setClabe={setClabe}
        cliente_id={cliente_id}
        user_rol={user_rol}
        clienteActualId={ClienteActualId}
        ProveedorGetService={ProveedorGetService}
        veTodos={veTodos}
      />
      <div className="container">
        <div className="crud-header">
          <Title title="Listado de Proveedores" className="crud-title" />
          {canManage ? (
            <button className="crud-add-btn" onClick={toggle}>
              <i className="bi bi-plus-lg"></i>
              Agregar proveedor
            </button>
          ) : (
            <ReadOnlyNote />
          )}
        </div>
        <div className="crud-card">
          <DataTable tableKey="proveedores" loading={loading} columns={columns} data={Proveedores} />
        </div>
      </div>
    </>
  );
}
